import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-form-flex',
  template: `
    <div
      class="row"
    >
      <formly-field *ngFor="let f of field.fieldGroup" [field]="f"  class="col-md-6">
      </formly-field>
    </div>
  `,
})
export class FlexLayoutType extends FieldType {
}